var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blog-widget-container"},[_c('h2',{staticClass:"blog-widget-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"blog-widget is-flex"},_vm._l((_vm.slugs),function(slug,index){return _c('CardVertical',{key:index,staticClass:"card",attrs:{"slug":slug}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }